<template>
  <div :class="{ 'timer-picker_active': active, 'timer-picker-wrap': true }" @click="showPicker">
    <span v-if="value" class="time-picker-text">{{ value }}</span>
    <span v-else class="time-picker-placeholder">{{ placeholder }}</span>
  </div>
</template>

<script>
import { i18n } from '@/common/utils/i18n'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    confirmTxt: {
      type: String,
      default: i18n.gettext('确定'),
    },
    minuteStep: {
      // 分钟数的步长
      type: Number,
      default: 1,
    },
  },
  data() {
    return { active: false }
  },
  computed: {
    // 将一天按步数1小时 转换成数组
    getHoursArray() {
      const totalHours = 24
      const hoursArray = []
      for (let i = 0; i < totalHours; i++) {
        const formattedSecond = (i < 10 ? '0' : '') + i
        hoursArray.push({
          text: formattedSecond,
          value: formattedSecond,
        })
      }
      return hoursArray
    },
    // 60分钟按步数1分钟 转换成数组
    getMinutesArray() {
      const totalMinutes = 60
      const minutesArray = []
      const step = this.minuteStep
      for (let i = 0; i < totalMinutes; i += step) {
        const formattedMinute = (i < 10 ? '0' : '') + i
        minutesArray.push({
          text: formattedMinute,
          value: formattedMinute,
        })
      }
      return minutesArray
    },
  },
  methods: {
    showPicker() {
      if (this.disabled) {
        return
      }
      this.showTimerPicker()
      this.active = true
    },
    getSelectIndex(hours, minutes) {
      const selectedIndex = [0, 0]
      if (this.value) {
        const [hour, minute] = this.value.split(':')
        const hourIdx = hours.findIndex(item => item.value === hour)
        const minuteIdx = minutes.findIndex(item => item.value === minute)
        if (hourIdx > -1) {
          selectedIndex[0] = hourIdx
        }
        if (minuteIdx > -1) {
          selectedIndex[1] = minuteIdx
        }
      }
      return selectedIndex
    },
    showTimerPicker() {
      const hours = this.getHoursArray
      const minutes = this.getMinutesArray
      const selectedIndex = this.getSelectIndex(hours, minutes)
      this.timePicker = this.$createPicker({
        selectedIndex,
        title: this.title,
        btnGroup: false,
        data: [hours, minutes],
        confirmTxt: this.confirmTxt,
        onSelect: this.selectHandler,
      })
      this.timePicker.show()
    },
    hided() {
      this.active = false
    },
    selectHandler(selectedTime, selectedText, formatedTime) {
      const hm = formatedTime.join(':')
      this.hided()
      if (hm !== this.value) {
        this.$emit('input', hm)
        this.$emit('change', hm)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
@import './style.scss';
</style>
